import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Organizations,
  CreateOrganizations,
  UpdateOrganizations,
  DeleteOrganizations,
  CategoryOrganization,
} from '../../../store/actions';

/**
 * OrganizationInjection is responsible for injecting the methods about store of organizations.
 *
 * @return
 *
 *
 *
 */
export const OrganizationsInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   *
   * @Organizations
   */
  const getOrganizations = useCallback(
    async (active) => {
      dispatch(Organizations(active));
    },
    [dispatch]
  );

  const getCategoryOrganizations = useCallback(async () => {
    dispatch(CategoryOrganization());
  }, [dispatch]);

  const createOrganizations = useCallback(
    async (data, history) => {
      dispatch(CreateOrganizations(data, history));
    },
    [dispatch]
  );

  const updateOrganizations = useCallback(
    async (id, data, history) => {
      dispatch(UpdateOrganizations(id, data, history));
    },
    [dispatch]
  );

  const deleteOrganizations = useCallback(
    async (id) => {
      dispatch(DeleteOrganizations(id));
    },
    [dispatch]
  );
  /**
   *
   *
  /**
  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * success: string
   */
  const { organizations, error, success, categoryOrganizations } = useSelector(
    (state) => ({
      error: state.Organizations.error,
      success: state.Organizations.success,
      organizations: state.Organizations.organizations,
      categoryOrganizations: state.CategoryOrganization.categoryOrganizations,
    })
  );

  return {
    // States
    error,
    success,
    organizations,
    categoryOrganizations,
    // Dispatchs
    getOrganizations,
    createOrganizations,
    updateOrganizations,
    deleteOrganizations,
    getCategoryOrganizations,
  };
};
